// extracted by mini-css-extract-plugin
module.exports = {"brandColor1":"#536e89","brandColor2":"#52c3df"};